import { 
  GetSteelEyeLogsSuccessPayload,
  GetMifidReportV2SuccessPayload,
  MifidReportPayload,

   } from '@/pages/ComplianceCentre/types';
import { createAsyncAction } from 'typesafe-actions';


//  -------------------------------
//  Fund Module Compliance  Page
//  ------------------------------- Good Stuffff

export const getSteelEyeLogs = createAsyncAction(
  'fundModule/getSteelEyeLogs/request',
  'fundModule/getSteelEyeLogs/success',
  'fundModule/getSteelEyeLogs/failure',
)<undefined, GetSteelEyeLogsSuccessPayload, undefined>();


export const getMifidReportV2 = createAsyncAction(
  'fundModule/getMifidReportV2/request',
  'fundModule/getMifidReportV2/success',
  'fundModule/getMifidReportV2/failure',
)<MifidReportPayload, GetMifidReportV2SuccessPayload, undefined>();
